import React from 'react'

import {
  Button,
  Flex,
  Heading,
  Image,
  useMediaQuery,
  Box,
  VStack,
  Text,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Input
} from "@chakra-ui/react";
import {ResgateProps} from '../dominio'
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';

const ResgateProcess = (props: any) => {
    const pageState: ResgateProps = props.pageState;
    const setPageState = props.setPageState;
    const resgateBanner = props.resgateBanner;
    const sucessoBanner = props.sucessoBanner;

    if (pageState.step === 1)
        return (<Step1  pageState={pageState} setPageState={setPageState} resgateBanner={resgateBanner}></Step1>);
    else if (pageState.step === 2)
        return (<Step2  pageState={pageState} setPageState={setPageState}></Step2>);
    else 
        return (<Step3  pageState={pageState} setPageState={setPageState} sucessoBanner={sucessoBanner}></Step3>);

    
}

export default ResgateProcess

